import React from 'react';

export default function HeadingsShowcase() {
  return (
    <div className="headings-showcase">
      <div className="h0">Heading 0 — Medium - 64</div>

      <h1>Heading 1 — Regular - 48</h1>
      <h2>Heading 2 — Bold - 32</h2>
      <h3>Heading 3 — Bold - 24</h3>

      <p>
        Body text Body text Body text Body text Body text Body text Body text Body text
      </p>

      <div className="body-small">Body — regular - 16</div>
      <div className="h0-tablet">H0 tablet — Regular - 48</div>
      <div className="h0-mobile">H0 mobile — Regular - 32</div>
    </div>
  );
}
